const API_URL = import.meta.env.PROD
  ? 'https://nexaigen.co.uk/api/contact'
  : '/api/contact';

export const sendContactEmail = async (data: {
  name: string;
  email: string;
  phone?: string;
  businessName?: string;
  services: string[];
  message: string;
}) => {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to send email');
  }

  return response.json();
};
